// extracted by mini-css-extract-plugin
module.exports = {"container":"Faq_container_99umL","text":"Faq_text_1rfws","icon":"Faq_icon_2ynWi"};